import { IDocInfo } from '@src/slide/domain/slide-app/core/interfaces/doc-info.interface';
// import { EditEvents } from '@src/slide/domain/slide-app/core/interfaces/event.interface';
import { DocInfoBaseManager } from '@src/slide/domain/slide-app/core/managers/doc-info-manager.ts';

export class LocalEditDocInfoManager extends DocInfoBaseManager {
    public async setDocVisible() {}

    protected getDocInfo(): Promise<IDocInfo> {
        return Promise.resolve({});
        // return new Promise((resolve) => {
        //     this.editEvent.on(EditEvents.SyncWorkerConnected, () => resolve({}));
        // });
    }
}
